import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import routes from '@/routes';
import LayoutDefault from '@/layouts/Default';
import Main from '@/pages/Main';
import Error from '@/pages/Error';
import Privacy from '@/pages/Privacy';
import Agreement from '@/pages/Agreement';
import Disclosure from '@/pages/Disclosure';
import Prices from '@/pages/Prices';
import EmptyLayout from '@/layouts/Empty';
import Personal from '@/pages/Personal';
import NegativeLayout from '@/layouts/Negative';
import Team from '@/pages/Team';
import Service from '@/pages/Service';
import Contact from '@/pages/Contact';
import LanguageLayout from '@/layouts/Language';

// paths are relative so the same pages can be nested under a language prefix
const relative = (path) => path.replace(/^\//, '');

const pages = (
  <>
    <Route element={<LayoutDefault />}>
      <Route path={relative(routes.privacy.path)} element={<Privacy />} />
      <Route path={relative(routes.agreement.path)} element={<Agreement />} />
      <Route path={relative(routes.disclosure.path)} element={<Disclosure />} />
      <Route path={relative(routes.prices.path)} element={<Prices />} />
      <Route path={relative(routes.team.path)} element={<Team />} />
    </Route>
    <Route element={<NegativeLayout />}>
      <Route path={relative(routes.service.path)} element={<Service />} />
      <Route path={relative(routes.personal.path)} element={<Personal />} />
      <Route path={relative(routes.contact.path)} element={<Contact />} />
    </Route>
    <Route element={<EmptyLayout />}>
      <Route index element={<Main />} />
    </Route>
  </>
);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<LanguageLayout />} errorElement={<Error />} >
      {pages}
      <Route path="en">
        {pages}
      </Route>
    </Route>,
  ),
);

export default router;
